import createLogger from 'vuex/dist/logger'; // eslint-disable-line

export default function (debug) {
  let plugins = [];

  if (debug) {
    const devPlugins = [];

    if (process.browser) {
      devPlugins.push(createLogger());
    }

    plugins = devPlugins;
  } else {
    plugins = plugins.concat([]);
  }

  return plugins;
}